export default "__VITE_ASSET__e0c14356__"